import { ChevronDown, ChevronRight, FileText, Hammer } from 'lucide-react';
import { useState } from 'react';

import type { ChatContextHit } from '../api/chat-stream.js';

export interface ToolCallCardProps {
  readonly hits: readonly ChatContextHit[];
  readonly onHitClick?: (hit: ChatContextHit) => void;
}

export function ToolCallCard({ hits, onHitClick }: ToolCallCardProps): JSX.Element | null {
  const [expanded, setExpanded] = useState(false);
  if (hits.length === 0) return null;

  return (
    <div className="ml-9 mb-2 overflow-hidden rounded-lg border border-blue-500/20 bg-blue-500/5">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
        className="flex w-full items-center gap-2 px-3 py-2 text-left transition-colors hover:bg-blue-500/10"
      >
        {expanded ? (
          <ChevronDown className="h-3 w-3 text-blue-300" />
        ) : (
          <ChevronRight className="h-3 w-3 text-blue-300" />
        )}
        <Hammer className="h-3 w-3 text-blue-300" />
        <span className="text-[11px] font-medium uppercase tracking-wider text-blue-300">
          retrieval
        </span>
        <span className="rounded-full bg-blue-500/15 px-1.5 py-0.5 text-[10px] font-mono text-blue-200">
          {hits.length}
        </span>
        <span className="text-[11px] text-text-muted">{hits.length === 1 ? 'hit' : 'hits'}</span>
      </button>
      {expanded && (
        <ul className="flex flex-col gap-0.5 border-t border-blue-500/15 px-2 py-2">
          {hits.map((h) => (
            <li key={h.id}>
              <button
                type="button"
                onClick={() => onHitClick?.(h)}
                className="group flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left transition-colors hover:bg-blue-500/10"
              >
                <FileText className="h-3 w-3 flex-none text-blue-400" />
                <span className="font-mono text-xs text-text-primary group-hover:text-blue-200">
                  {h.name}
                </span>
                {h.filePath && (
                  <span className="ml-auto truncate text-[10px] text-text-muted">{h.filePath}</span>
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
